import { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button, Card } from "@mui/material";
import { postobj } from "../apicall/apicall";
import FormControl from "@mui/material/FormControl";
import { NotificationManager } from "react-notifications";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
import { validated } from "../apicall/validateform";
import { validateField } from "../apicall/commonFunction";
import { dist } from "../apicall/constants";

import {
  buttonStyle,
  form_add,
} from "../style/style";

export default function AddUser(props) {
  const [user, setuser] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    company_name: "",
    company_address: "",
    zip_code: "",
    city: "",
    state: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { value, name } = e.target;
    setuser({
      ...user,
      [name]: value,
    });
  };

  const addProfile = async (id) => {
    //console.log("TEDT", id);
    user["id"] = id;
    let url = process.env.REACT_APP_ZEWA_URL + "user/customer-profile/";
    const d = postobj(url, user);
    d.then(function (res) {
      // console.log(res.id);
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.success("Organization added Successfully")
      props.setadduser(false);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validated(user) && validateForm()) {
      setErrors({})
      let url =
        process.env.REACT_APP_ZEWA_URL + "user/add-customer/?role=CUSTOMER";
      const d = postobj(url, user);
      d.then(function (res) {
        
        if (res.Message === "User already exists") {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(res.Message);
        } else {
          addProfile(res.id);
        }
      }).catch((err) => {
        console.log(err.Message);

        //NotificationManager.error(err.Message)
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!user.first_name.trim()) {
      newErrors.first_name = 'First Name cannot be blank';
    }

    if (!user.last_name.trim()) {
      newErrors.last_name = 'Last Name cannot be blank';
    }

    if (!/^\d{1,10}$/.test(user.phone)) {
      newErrors.phone = 'Please enter a 10-digit phone number';
    }

    if (!user.company_name.trim()) {
      newErrors.company_name = 'Company Name cannot be blank';
    }

    if (!user.company_address.trim()) {
      newErrors.company_address = 'Company Address cannot be blank';
    }

    if (!user.state.trim()) {
      newErrors.state = 'State cannot be blank';
    }

    if (!user.city.trim()) {
      newErrors.city = 'City cannot be blank';
    }

    if (!/^\d{1,5}$/.test(user.zip_code)) {
      newErrors.zip_code = 'Please enter a 5-digit zip code';
    }

    let val = validateField(user, dist);
    console.log(val, "--------------------------------");
    if (Object.keys(val).length > 0) {
      Object.keys(val).forEach((field) => {
        console.log(field);
        newErrors[field] = val[field];
      });}

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }
    return true;
  }

  return (
    <Box>
      <Card sx={{ padding: "25px" }}>
        <form onSubmit={handleSubmit}>
          <FormControl fullWidth>
            <TextField
              error={errors.first_name || false}
              id="outlined-error-helper-text"
              label="Enter first name"
              name="first_name"
              sx={form_add}
              value={user.first_name}
              onChange={(e) => {
                handleChange(e);
              }}
              required
              helperText={errors.first_name ? errors.first_name : ''}
            />

            <TextField
              error={errors.last_name || false}
              id="outlined-error-helper-text"
              label="Enter last name"
              name="last_name"
              sx={form_add}
              value={user.last_name}
              onChange={(e) => {
                handleChange(e);
              }}
              required
              helperText={errors.last_name ? errors.last_name : ''}
            />

            <TextField
              id="outlined-multiline-flexible"
              label="Enter user email"
              name="email"
              type="email"
              sx={form_add}
              value={user.email}
              onChange={(e) => {
                handleChange(e);
              }}
              required
            />
            <TextField
              error={errors.phone || false}
              id="outlined-error-helper-text"
              label="Enter phone number"
              sx={form_add}
              value={user.phone}
              name="phone"
              onChange={(e) => {
                handleChange(e);
              }}
              helperText={errors.phone ? errors.phone : ''}
              required
            />

            <TextField
              error={errors.company_name || false}
              id="outlined-error-helper-text"
              label="Enter company name"
              name="company_name"
              sx={form_add}
              value={user.company_name}
              onChange={(e) => {
                handleChange(e);
              }}
              required
              helperText={errors.company_name ? errors.company_name : ''}
            />
            <TextField
              error={errors.company_address || false}
              id="outlined-error-helper-text"
              label="Enter company address"
              value={user.company_address}
              name="company_address"
              sx={form_add}
              onChange={(e) => {
                handleChange(e);
              }}
              required
              helperText={errors.company_address ? errors.company_address : ''}
            />

            <TextField
              error={errors.city || false}
              id="outlined-error-helper-text"
              label="Enter city name"
              sx={form_add}
              value={user.city}
              name="city"
              onChange={(e) => {
                handleChange(e);
              }}
              required
              helperText={errors.city ? errors.city : ''}
            />
            <TextField
              error={errors.state || false}
              id="outlined-error-helper-text"
              label="Enter State"
              name="state"
              value={user.state}
              sx={form_add}
              onChange={(e) => {
                handleChange(e);
              }}
              required
              helperText={errors.state ? errors.state : ''}
            />
            <TextField
              error={errors.zip_code || false}
              id="outlined-error-helper-text"
              label="Enter zipcode"
              sx={form_add}
              value={user.zip_code}
              name="zip_code"
              onChange={(e) => {
                handleChange(e);
              }}
              required
              helperText={errors.zip_code ? errors.zip_code : ''}
            />

            <Box m={-1}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={buttonStyle}
              >
                Add
              </Button>
              <Button
                variant="contained"
                color="error"
                style={buttonStyle}
                onClick={(e) => {
                  props.setadduser(false);
                }}
              >
                cancel
              </Button>
            </Box>
          </FormControl>
        </form>
      </Card>
      <NotificationContainer />
    </Box>
  );
}
